const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { MediaUpload, InspectorControls } = wp.blockEditor;
const { useSelect } = wp.data;
const { TextControl, Panel, PanelBody, ExternalLink, PanelRow, Icon } =
	wp.components;
const { serverSideRender: ServerSideRender } = wp;
import { useState } from "react";

const { __experimentalLinkControlSearchInput: LinkControlSearchInput } =
	wp.blockEditor;

registerBlockType(
	"qteblocks/block-short-links", // Name of the block with a required name space
	{
		title: "3 Länkar Banner",
		description: "3 Länkar Banner",
		icon: "admin-links", // Icon, from WP icons
		category: "qteblocks",

		attributes: {
			linkOne: {
				type: "string",
				default: "",
			},
			linkTwo: {
				type: "string",
				default: "",
			},
			linkThree: {
				type: "string",
				default: "",
			},
			titleOne: {
				type: "string",
				default: "",
			},
			titleTwo: {
				type: "string",
				default: "",
			},
			titleThree: {
				type: "string",
				default: "",
			},
		},

		edit(props) {
			var attributes = props.attributes;

			return (
				<>
					<InspectorControls>
						<Panel>
							<PanelBody
								title="Blockinställningar"
								icon={<Icon icon="admin-generic" />}
								initialOpen={true}
							>
								<PanelRow>
									<TextControl
										label="Title 1"
										value={attributes.titleOne}
										onChange={(value) => props.setAttributes({ titleOne: value })
										}
									/>
								</PanelRow>
								<PanelRow>
									<TextControl
										label="Link 1"
										value={attributes.linkOne}
										onChange={(value) => props.setAttributes({ linkOne: value })
										}
									/>
								</PanelRow>
								<PanelRow>
									<TextControl
										label="Title 2"
										value={attributes.titleTwo}
										onChange={(value) => props.setAttributes({ titleTwo: value })
										}
									/>
								</PanelRow>
								<PanelRow>
									<TextControl
										label="Link 2"
										value={attributes.linkTwo}
										onChange={(value) => props.setAttributes({ linkTwo: value })
										}
									/>
								</PanelRow>
								<PanelRow>
									<TextControl
										label="Title 3"
										value={attributes.titleThree}
										onChange={(value) => props.setAttributes({ titleThree: value })
										}
									/>
								</PanelRow>
								<PanelRow>
									<TextControl
										label="Link 3"
										value={attributes.linkThree}
										onChange={(value) =>
											props.setAttributes({ linkThree: value })
										}
									/>
								</PanelRow>
							</PanelBody>
						</Panel>
					</InspectorControls>
					<ServerSideRender
						block="qteblocks/block-short-links"
						attributes={props.attributes}
					/>
				</>
			);
		},

		save(props) {
			return null; // See PHP side. This block is rendered on PHP.
		},
	},
);
